// Universal Utilties Plugin 
// Enables utils.js as global functions
// Installed in main.js
// Use from any component: let word = this.uu.genWord(6);

import * as Utils from './utils.js';

// Factory Install function for Plugin
const UUtils = {
	install: (Vue, options) => {
		// Vue.prototype.u = {};
		Vue.prototype.ublur = Utils.blur;
		Vue.prototype.ugenWord = Utils.genWord;
		Vue.prototype.uconvert2Recordset = Utils.convert2Recordset;
		Vue.prototype.ucalcVisDate = Utils.calcVisDate;
		Vue.prototype.uvaliDateStr = Utils.valiDateStr;
	}
}

export default UUtils;
